module.exports = __webpack_public_path__ + "img/contact_us@2x.5330bb55.jpg";